<script setup lang="ts">
import { computed } from "vue";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import en from "element-plus/es/locale/lang/en";
import { lang } from "./i18n";

// Element Plus 自带文字(分页「共 N 条」、日期选择器、空表格)跟着界面语言走
const elLocale = computed(() => (lang.value === "en" ? en : zhCn));
</script>

<template>
  <el-config-provider :locale="elLocale">
    <router-view />
  </el-config-provider>
</template>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  font-family: -apple-system, "PingFang SC", "Segoe UI", sans-serif;
}
</style>
